import { IonCol, IonRow, IonText } from '@ionic/react';

/** The Run Kinematics report tab */
import {
  AnkleStiffnessModalContent,
  HipLockModalContent,
  KneeExtenstionTerminalStanceRunModalContent,
  SwingLegRecoveryModalContent,
  KneeFlexionMidSwingRunModalContent,
  SwingLegRetractionModalContent,
  ScissorsModalContent,
  FootplantFromAboveModalContent,
  ProjectionFootplantModalContent,
  KneeFlexionMidstanceRunModalContent,
  PositiveRunningMidstanceModalContent,
  PositiveRunningToeOffModalContent,
} from '@/pages/ReportV2/components/Modals';

import { AttractorCard } from '@/components/Cards';

import AnkleStiffness from '@/assets/avatars/run/analysis/AnkleStiffness.png';
import FootPlant from '@/assets/avatars/run/analysis/FootPlant.png';
import HipLock from '@/assets/avatars/run/analysis/HipLock.png';
import KneeAngleMidswing from '@/assets/avatars/run/analysis/KneeAngleMidswing.png';
import KneeExtensionPreswing from '@/assets/avatars/run/analysis/KneeExtensionPreswing.png';
import KneeFlexionMidstance from '@/assets/avatars/run/analysis/kneeFlexionMidstance.png';
import PositiveRunningMidstance from '@/assets/avatars/run/analysis/PositiveRunningMidstance.png';
import PositiveRunningToeOff from '@/assets/avatars/run/analysis/PositiveRunningToeOff.png';
import ProjectionFootplant from '@/assets/avatars/run/analysis/ProjectionFootplant.png';
import Scissors from '@/assets/avatars/run/analysis/Scissors.png';
import SwingLegRecovery from '@/assets/avatars/run/analysis/SwingLegRecovery.png';
import SwingLegRetraction from '@/assets/avatars/run/analysis/SwingLegRetraction.png';

import { RunAttractorData } from '@/models/reportV2.model';

type AttractorsReportProps = {
  tabData: RunAttractorData;
};

/** Run kinematics report tab
 * @param report - the full run report info and data
 */
export const RunAttractorsReportTab = ({ tabData }: AttractorsReportProps) => {
  if (!tabData) {
    return <IonText>Data not found.</IonText>;
  }
  return (
    // <IonPage>
    //   <IonContent className={styles.content} id='main' color='light'>
    //     <IonGrid fixed style={{ height: '100%' }}>

    <>
      <IonRow>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.attractorData[1]}
            img={AnkleStiffness}
            info={<AnkleStiffnessModalContent />}
            labels={tabData.attractorLabels[1]}
            subtitle='Terminal stance'
            title='Ankle stiffness'
          />
        </IonCol>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.attractorData[2]}
            img={KneeExtensionPreswing}
            info={<KneeExtenstionTerminalStanceRunModalContent />}
            labels={tabData.attractorLabels[2]}
            subtitle='Terminal stance'
            title='Knee extension'
          />
        </IonCol>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.attractorData[3]}
            img={HipLock}
            info={<HipLockModalContent />}
            labels={tabData.attractorLabels[3]}
            subtitle='Terminal stance'
            title='Hip lock'
          />
        </IonCol>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.attractorData[0]}
            img={PositiveRunningToeOff}
            info={<PositiveRunningToeOffModalContent />}
            labels={tabData.attractorLabels[0]}
            subtitle='Toe-off'
            title='Positive running'
          />
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.attractorData[5]}
            img={SwingLegRecovery}
            info={<SwingLegRecoveryModalContent />}
            labels={tabData.attractorLabels[5]}
            subtitle='Initial swing'
            title='Swing leg recovery'
          />
        </IonCol>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.attractorData[6]}
            img={KneeAngleMidswing}
            info={<KneeFlexionMidSwingRunModalContent />}
            labels={tabData.attractorLabels[6]}
            subtitle='Midswing'
            title='Knee flexion'
          />
        </IonCol>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.attractorData[9]}
            img={SwingLegRetraction}
            info={<SwingLegRetractionModalContent />}
            labels={tabData.attractorLabels[9]}
            subtitle='Terminal Swing'
            title='Swing leg retraction'
          />
        </IonCol>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.attractorData[10]}
            img={Scissors}
            info={<ScissorsModalContent />}
            labels={tabData.attractorLabels[10]}
            subtitle='Terminal swing'
            title='Scissors motion'
          />
        </IonCol>
      </IonRow>

      <IonRow className='ion-padding-bottom'>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.attractorData[11]}
            img={FootPlant}
            info={<FootplantFromAboveModalContent />}
            labels={tabData.attractorLabels[11]}
            subtitle='Midstance'
            title='Footplant from above'
          />
        </IonCol>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.attractorData[8]}
            img={ProjectionFootplant}
            info={<ProjectionFootplantModalContent />}
            labels={tabData.attractorLabels[8]}
            subtitle='Midstance'
            title='Projection footplant'
          />
        </IonCol>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.attractorData[14]}
            img={KneeFlexionMidstance}
            info={<KneeFlexionMidstanceRunModalContent />}
            labels={tabData.attractorLabels[14]}
            subtitle='Midstance'
            title='Knee flexion'
          />
        </IonCol>
        <IonCol size-lg='3' size-md='6' size-sm='12'>
          <AttractorCard
            attractorRow={tabData.attractorData[7]}
            img={PositiveRunningMidstance}
            info={<PositiveRunningMidstanceModalContent />}
            labels={tabData.attractorLabels[7]}
            subtitle='Midstance'
            title='Positive running'
          />
        </IonCol>
      </IonRow>
    </>
    //     </IonGrid>
    //   </IonContent>
    // </IonPage>
  );
};
